import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_ENTERPRISE_DEMO_IEAM_END = {
  title:
    "Find out more about Infosys Edge\n Application Management from our staff.",
  bgImage: "ENG/IEAM/IEAM_Introduction_01.png",
  optionsButtons: [
    {
      label: "Overview",
      onClick: () => setCurrentPage("ENG_101"),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "RESTART DEMO",
      onClick: () => setCurrentPage("ENG_111"),
      type: "transparent",
      startIcon: "arrow-left",
    },
    {
      label: "SELECT ANOTHER DEMO",
      onClick: () => setCurrentPage("ENG_104"),
      endIcon: "arrow-right",
    },
  ],
};
